"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Spacer = void 0;

var _spacer = _interopRequireDefault(require("./components/spacer"));

exports.Spacer = _spacer["default"];